import React, { Component } from "react";
import { connect } from "react-redux";
import { strings } from "../../resources/Strings";

class AuthErrorIndicator extends Component {
  render() {
    return (
      <div
        className={
          this.props.error || this.props.formError || this.props.loading
            ? "invalid-feedback d-block mb-2"
            : "invalid-feedback d-block"
        }
      >
        {this.props.error ? this.props.error.message : null}
        {this.props.formError ? this.props.formError : null}
        {this.props.loading ? strings.loading : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.auth.error,
    loading: state.auth.loading
  };
};

export default connect(mapStateToProps)(AuthErrorIndicator);
